<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="item-detail-page" class="mt-4 flex p-2 sm:p-8">

    <vx-card no-radius no-shadow class="relative overflow-hidden" v-if="item_data" :key="item_data.id">
      <div class="absolute bg-success px-10 py-2 text-white text-bold text-center" style="width: 200px; top: 20px; left: -50px; transform: rotate(-45deg);" v-show="onSale">PROMOCIÓN<br/><b>Antes Q{{ item_data.originalPrice }}</b></div>
      <div class="absolute top-0 right-0">
        <vs-icon icon="cancel" class="m-4 cursor-pointer text-warning" size="large" @click="$router.push({name: 'category-view'}).catch(err => {})"/>
      </div>

      <template slot="no-body">

        <div class="item-content">

          <!-- Item Main Info -->
          <div class="product-details p-6">
            <div class="vx-row mt-6">
              <div class="vx-col lg:w-2/5 w-full flex items-center justify-center">
                <!--                <div class="product-img-container w-3/5 mx-auto mb-10 lg:mb-0">-->
                <image-magnifier class="hidden lg:flex" :src="getImage(item_data, imageHeight)" :zoom-src="getImage(item_data, imageHeight * 2)" :height="imageHeight" :zoom-width="imageHeight * 1.5" :zoom-height="imageHeight * 1.25"/>
                <img :src="getImage(item_data, imageHeight)" :alt="item_data.name" class="flex lg:hidden mx-auto" rel="preload">
              </div>

              <!-- Item Content -->
              <div class="vx-col lg:w-3/5 w-full">

                <h3>{{ item_data.name }}</h3>

                <p class="flex items-center flex-wrap">
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">Q{{ item_data.price.toFixed(2) }}</span>
                </p>

                <vs-divider/>

                <!-- Quantity -->
                <div class="vx-row">

                  <div class="vx-col w-full">
                    Cantidad: <vs-input-number v-if="item_data.available" :min="1" max="24" :value="quantity" @input="updateItemQuantity($event)" class="inline-flex"/>
                    <p class="my-2">
                      <span class="text-success" v-if="item_data.available">Disponible</span>
                      <span class="text-danger" v-else>No disponible</span>
                    </p>
                  </div>

                  <div class="vx-col w-full" v-if="item_data.available">
                    <div class="flex flex-wrap items-start mb-4">

                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4 mb-4 bg-success"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        v-if="!isInCart(item_data.id) && item_data.status == 'ACT'"
                        @click="toggleItemInCart(item_data)">
                        AGREGAR
                      </vs-button>

                      <vs-button
                        v-if="isInCart(item_data.id)"
                        class="mr-4 mb-4 bg-warning"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        color="success"
                        @click="$router.push({name: 'checkout'}).catch(err => {})">
                        VER EN PEDIDO
                      </vs-button>
                      <!-- /Add To Cart Button -->

                    </div>
                  </div>
                </div>

                <div class="text-primary text-lg mb-2" v-if="variations.length > 0">Otras presentaciones</div>
                <div class="vx-row flex" v-if="variations.length > 0">
                  <vx-card class="m-2 w-full md:w-1/5 flex justify-center items-center cursor-pointer" v-for="item in variations" :key="item.id" @click="navigate_to_detail_view(item)">
                    <vx-tooltip position="top" :text="item.name" class="flex flex-col justify-center items-center mb-2">
                      <img :src="getImage(item, 80)" :alt="item.name" class="mx-auto" rel="preload">
                      <div class="flex flex-col text-bold">
                        Q{{ item.price.toFixed(2) }}
                      </div>
                    </vx-tooltip>
                  </vx-card>
                </div>
                <!-- /Quantity -->

                <!-- Social links -->
                <!--                <div class="vx-row">-->
                <!--                  <div class="vx-col flex flex-wrap items-center">-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#1551b1" icon="icon-facebook" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#00aaff" icon="icon-twitter" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#c4302b" icon="icon-youtube" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#405DE6" icon="icon-instagram" radius></vs-button>-->
                <!--                  </div>-->
                <!--                </div>-->

              </div>

            </div>
          </div>

          <!--
                     Product Feature/Meta Row
                              <div class="py-24 mb-16 mt-10 text-center item-features">
                                <div class="vx-row">
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto mb-16 md:mb-0">
                                      <feather-icon icon="AwardIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">100% Original</span>
                                      <p class="mt-2">Chocolate bar candy canes ice cream toffee cookie halvah.</p>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto mb-16 md:mb-0">
                                      <feather-icon icon="ClockIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">10 Day Replacement</span>
                                      <p class="mt-2">Marshmallow biscuit donut dragée fruitcake wafer.</p>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto">
                                      <feather-icon icon="ShieldIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">1 Year Warranty</span>
                                      <p class="mt-2">Cotton candy gingerbread cake I love sugar sweet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
          -->

        </div>

        <!-- Related Products -->
        <div v-if="hasRelated" class="related-products text-center flex flex-col items-center justify-center px-10 mt-4 max-w-sm md:max-w-xl mx-8 lg:max-w-3xl xl:max-w-4xl">

          <div class="related-headings mb-8 text-center">
            <h3 class="uppercase">Productos relacionados</h3>
            <p>Otros productos que le pueden interesar</p>
          </div>
          <carousel
            :autoplay="false"
            :loop="true"
            :perPage="1"
            :perPageCustom="[[768, 2],[992, 3], [1200, 4], [1600, 5]]"
            :paginationEnabled="false"
            :navigationEnabled="true"
            class="related-product-swiper"
          >
            <slide v-for="item in related_items" :key="item.id" class="p-4">
              <vx-card class="overflow min-w-32 md:min-w-64">

                <!-- Item Heading -->
                <div class="item-heading mb-4">
                  <p class="text-lg font-semibold truncate">{{ item.name }}</p>
                  <!--                <p class="text-sm">-->
                  <!--                  <span class="mr-2">by</span>-->
                  <!--                  <span>{{ item.brand }}</span>-->
                  <!--                </p>-->
                </div>

                <!-- Item Image -->
                <div class="img-container w-32 mx-auto my-base">
                  <img :src="getImage(item, 110)" :alt="item.name" class="mx-auto" rel="preload">
                </div>

                <!-- Item Meta -->
                <div class="item-meta">
                  <star-rating :show-rating="false" :rating="item.rating" :star-size="14" class="justify-center" read-only/>
                  <p class="text-lg font-medium text-primary">Q{{ item.price }}</p>
                  <div class="mt-2 justify-center flex">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-search"
                      @click="navigate_to_detail_view(item)"
                    >
                      VER
                    </vs-button>
                  </div>
                </div>
              </vx-card>
            </slide>
          </carousel>
        </div>

        <vs-tabs class="mx-4">
          <vs-tab label="Descripción">
            <p>{{ item_data.description }}</p>
          </vs-tab>
          <vs-tab label="Especificaciones">
            <div class="flex flex-row w-full mb-2">
              <div class="flex w-full sm:w-1/5 text-lg text-big">
                ISBN
              </div>
              <div class="flex w-full sm:w-4/5 text-lg">
                {{ item_data.isbn }}
              </div>
            </div>
            <div class="flex flex-row w-full mb-2">
              <div class="flex w-full sm:w-1/5 text-lg">
                Categorías
              </div>
              <div class="flex w-full sm:w-4/5 text-lg">
                <vs-chip color="success" class="mr-3" v-for="category in item_data.categoryIds" :key="category.id">{{ category.name }}</vs-chip>
              </div>
            </div>
            <div class="flex flex-row w-full mb-2">
              <div class="flex w-full sm:w-1/5 text-lg">
                Versión
              </div>
              <div class="flex w-full sm:w-4/5 text-lg">
                <span class="mr-3" v-for="version in item_data.versionIds" :key="version.id">{{ version.name }}</span>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Multimedia" v-if="item_data.videoURL != ''">
            <youtube :video-id="videoId" :player-width="playerWidth" :player-height="playerHeight" class="mt-4"></youtube>
          </vs-tab>
        </vs-tabs>


      </template>
    </vx-card>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Carousel, Slide} from 'vue-carousel';
  import StarRating from 'vue-star-rating'
  import {ImageMagnifier} from 'vue-image-magnifier';
  import VueYouTubeEmbed from 'vue-youtube-embed';
  Vue.use(VueYouTubeEmbed);

  export default {
    components: {
      Carousel,
      Slide,
      StarRating,
      ImageMagnifier
    },
    data() {
      return {
        item_data: null,
        quantity: 1,
        error_occured: false,
        error_msg: '',

        // Related Products Swiper
        swiperOption: {
          slidesPerView: 4,
          spaceBetween: 55,
          // breakpoints: {
          //   1600: {
          //     slidesPerView: 4,
          //     spaceBetween: 55
          //   },
          //   1300: {
          //     slidesPerView: 3,
          //     spaceBetween: 55
          //   },
          //   900: {
          //     slidesPerView: 2,
          //     spaceBetween: 55
          //   },
          //   640: {
          //     slidesPerView: 1,
          //     spaceBetween: 55
          //   }
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },

        // Below is data which is common in any item
        // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
        available_item_colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
        opt_color: '#7367F0',
        is_hearted: false,

        related_items: [{id: 1}, {id: 4}, {id: 7}, {id: 10}, {id: 13}]
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      imageHeight() {
        if (this.windowWidth < 400) {
          return 200;
        } else if (this.windowWidth < 600) {
          return 250;
        } else {
          return 350;
        }
      },
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      item_qty() {
        const item = this.$store.getters['eCommerce/getCartItem'](this.item_data.id)
        return Object.keys(item).length ? item.quantity : 1
      },
      itemColor() {
        return (obj) => {
          const style_obj = {}

          obj.style.forEach(p => {
            style_obj[p] = obj.color
          });

          return style_obj
        }
      },
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      hasRelated() {
        return (this.item_data.hasOwnProperty('relatedProducts') && this.item_data.relatedProducts.length > 0);
      },
      variations() {
        if (this.item_data.hasOwnProperty('variations')) {
          return this.$store.getters['fullProductsList'].filter(item => this.item_data.variations.split(',').includes(item.id.toString()));
        } else {
          return [];
        }
      },
      onSale() {
        if (this.item_data.hasOwnProperty('onSale')) {
          return this.item_data.onSale;
        } else {
          return false;
        }
      },
      playerWidth() {
        if (this.windowWidth < 640) {
          return this.windowWidth * 0.85;
        } else {
          return 640;
        }
      },
      playerHeight() {
        if (this.windowWidth < 640) {
          return this.windowWidth * 0.85 * 0.75;
        } else {
          return 360;
        }
      },
      videoId() {
        return this.$youtube.getIdFromURL(this.item_data.videoURL);
      }
    },
    watch: {
      // call again the method if the route changes
      '$route': function () {
        this.fetch_item_details(this.$route.params.item);
      }
    },
    methods: {
      toggleItemInCart(item) {
        this.$store.dispatch('eCommerce/toggleItemInCart', item);
        if (this.quantity > 1) {
          this.updateItemQuantity(this.quantity);
        }
      },
      fetch_item_details(item_id) {
        var item = this.$store.getters.fullProductsList.filter(item => item.id == item_id);
        if (item.length > 0) {
          this.item_data = item[0];
          this.quantity = this.item_qty;
        } else {
          this.$store.dispatch('updateHomeScreen', 2);
          this.$router.push('/');
        }
      },
      getImage(item, height) {
        const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.png?alt=media'].join('');
        return imageURL;
      },
      updateItemQuantity(event) {
        this.quantity = parseInt(event);
        const index = this.$store.getters['eCommerce/getCartItemIndex'](this.item_data.id);
        if (index >= 0) {
          this.$store.dispatch('eCommerce/updateItemQuantity', {index: index, quantity: this.quantity})
        }
      },
      navigate_to_detail_view(item) {
        this.$router.push({name: 'item-detail-view', params: {item: item.id}}).catch(() => {
        });
        // this.fetch_item_details(item);
      },
      handleClickSlide(index, reallyIndex) {
        console.log('Click slide!', index, reallyIndex)
      },
      onSelected(object) {
        var index = object.attributes['data-swiper-slide-index'].nodeValue;
        console.log('you have selected slide' + index)
      }
    },
    created() {
      window._this = this
      this.fetch_item_details(this.$route.params.item);
      // var product = null;
      // for (var i = 0; i < this.related_items.length; i++) {
      //   product = this.$store.state.products.filter(item => item.id == this.related_items[i].id);
      //   if (product) {
      //     this.related_items[i].isbn = product[0].isbn;
      //     this.related_items[i].name = product[0].name;
      //     this.related_items[i].price = product[0].price;
      //   }
      // }
    }
  }
</script>

<style lang="scss">

  @import "@/assets/scss/vuexy/_variables.scss";

  #item-detail-page {
    .color-radio {
      height: 2.28rem;
      width: 2.28rem;

      > div {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .item-features {
      background-color: #f7f7f7;

      .theme-dark & {
        background-color: $theme-dark-secondary-bg;
      }
    }

    .product-sales-meta-list {
      .vs-list--icon {
        padding-left: 0;
      }
    }

    .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

      .swiper-wrapper {
        padding-bottom: 2rem;

        > .swiper-slide {
          background-color: #f7f7f7;
          box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

          .theme-dark & {
            background-color: $theme-light-dark-bg;
          }
        }
      }

      .swiper-button-next,
      .swiper-button-prev {
        transform: scale(.5);
        filter: hue-rotate(40deg);
      }

      .swiper-button-next {
        right: 0
      }

      .swiper-button-prev {
        left: 0;
      }
    }
  }
</style>
